import React, { useState } from "react";
import Loader from "../../../components/loader";
import { useBalancerPoolsData } from "../../../context/balancerPoolData";
import { PoolType } from "../../poolDetail/balancer/types";
import Web3 from "web3";

import { useGlobal } from "../../../context/globalContext";
import UiTable from "../../../components/table/Table";
import UiButton from "../../../components/button";
import {
  PrimaryIssueManager,
  contractAddress,
} from "@verified-network/verified-sdk";
import { useSupportedTokens } from "../../../context/contractDataLoaderService";
import AddDetails from "../../custodian/details";
import VerticallyModal from "../../../components/modal/VerticallyModal";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";
import { Col, Row } from "react-bootstrap";

function ServicerHome(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    isUpdate,
    setIsUpdate,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  let { data, loading } = useBalancerPoolsData(PoolType.PrimaryIssue, isUpdate);
  let { data: secondaryPools } = useBalancerPoolsData(PoolType.SecondaryIssue);
  const [showModal, setShowModal] = useState(false);
  const [showPayoff, setShowPayoff] = useState(false);
  const [payoffAmount, setPayoffAmount] = useState("");
  const [schelduleTime, setSchelduleTime] = useState("");
  const [payoffAssetId, setPayoffAssetId] = useState("");
  let { data: supportedTokens } = useSupportedTokens();

  if (userRole === "DP" || userRole === "intermediary") {
    const secondaryPoolSecurities = secondaryPools.map((pool) =>
      pool?.security?.toLowerCase()
    );
    data = data.filter(
      (pool) =>
        pool?.verifiedWalletData?.issueManager?.toLowerCase() ===
          account.toLowerCase() &&
        pool?.verifiedWalletData?.subscriptionsClosed?.length
    );
    data = data.map((pool) => {
      if (secondaryPoolSecurities.includes(pool?.security?.toLowerCase())) {
        return {
          ...pool,
          issuedSecondary: true,
          isFiat: supportedTokens.find(
            (token) =>
              token?.tokenAddress?.toLowerCase() ===
              pool?.currency?.toLowerCase()
          ).isFiat,
        };
      } else {
        return {
          ...pool,
          isFiat: supportedTokens.find(
            (token) =>
              token?.tokenAddress?.toLowerCase() ===
              pool?.currency?.toLowerCase()
          ).isFiat,
        };
      }
    });
  } else if (userRole == "AM")
    data = data.filter(
      (pool) =>
        pool?.verifiedWalletData?.liquidityProviders?.find(
          (obj) => obj.owner.id.toLowerCase() === account.toLowerCase()
        ) && pool?.verifiedWalletData?.subscriptionsClosed?.length
    );

  let primaryIssueManagerContract;
  if (provider && provider.getSigner && chainId && address) {
    const BalancerPrimaryIssueManager =
      contractAddress[chainId].BalancerPrimaryIssueManager;
    if (BalancerPrimaryIssueManager) {
      primaryIssueManagerContract = new PrimaryIssueManager(
        signer,
        BalancerPrimaryIssueManager,
        "balancer"
      );
    }
  }

  let headers = [
    { label: "Security", val: "security" },
    { label: "Company", val: "companyName" },
    { label: "Currency", val: "currency" },
    { label: "Close Date(UTC)", val: "cutoffTime" },
    userRole == "DP" || userRole == "intermediary"
      ? { label: "Call Action", val: "closedIssuesAction" }
      : { label: "Call Action", val: "managerEarnings" },
  ];

  const options = {
    onClick: (event, row) => {
      onInvest(row);
    },
  };
  const onInvest = (row) => {
    props.history.push(
      `/closed_issues/primary_investors/${row.poolType}/${row.security}`
    );
  };

  const commonProps = {
    showPayoff,
    updateShowPayoff: setShowPayoff,
    schelduleTime,
    updateSchelduleTime: setSchelduleTime,
    payoffAmount,
    updatePayoffAmount: setPayoffAmount,
    payoffAssetId,
    updatePayoffAssetId: setPayoffAssetId,
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <section className="d-flex flex-column align-items-start px-0 py-4">
        <div className="mb-3 d-flex justify-content-between w-100 align-items-center">
          <div className="w-100">
            <h3 className="text-left">Closed Issues</h3>
          </div>
          {userRole != "AM" && (
            <div className="w-50 text-right">
              <UiButton
                onClick={() => {
                  setShowModal(true);
                }}
                buttonVariant="primary"
                buttonClass="flex-1 ml-0"
                buttonText="Link Bank Account"
                type="submit"
              />
            </div>
          )}
        </div>
        <div className="w-100">
          <div className="pools-table width-100">
            <UiTable
              thead={headers}
              tbodyData={data || []}
              hover
              bordered={false}
              userRole={userRole}
              rowEvents={options}
              chainId={chainId}
              web3={web3}
              account={account}
              signer={signer}
              useGlobal={useGlobal}
              isUpdate
              updateTableData={setIsUpdate}
              contract={primaryIssueManagerContract}
              commonProps={commonProps}
              verifiedWalletDetails={verifiedWalletDetails}
            />
          </div>
        </div>
      </section>
      <VerticallyModal
        key="showDetails"
        showModal={showModal}
        modalOnHide={() => {
          setShowModal(false);
        }}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>Create Custody Account</b>
          </h2>
        }
        withFooter={false}
      >
        <AddDetails isCustodian={false} />
      </VerticallyModal>
      <VerticallyModal
        key="showPayoff"
        showModal={showPayoff}
        modalOnHide={() => {
          setShowPayoff(false);
        }}
        modalSize={"lg"}
        modalHeading={
          <h2>
            <b>Asset Next Pay Off Details</b>
          </h2>
        }
        withFooter={false}
      >
        <div className="d-grid gap-2">
          <Row className="ml-1 align-items-center">
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Asset Id</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <p>{payoffAssetId}</p>
              </Col>
            </Row>
            {schelduleTime?.length > 0 && (
              <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
                <Col xs={{ span: 3, offset: 2 }} className="text-left">
                  <b>Next Scheldule Event</b>
                </Col>
                <Col className="pl-0" xs={5}>
                  <p>{schelduleTime}</p>
                </Col>
              </Row>
            )}
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Pay Off</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <p>{payoffAmount}</p>
              </Col>
            </Row>
          </Row>
        </div>
      </VerticallyModal>
    </>
  );
}

export default function ClosedIssues(props) {
  return <ServicerHome {...props} />;
}
